<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
      <!-- <p>
        <b>Подробная программа будет опубликована позднее</b>
      </p>
        <p>
        <b>Работа форума будет осуществляться по трем секциям и двум микросимпозиумам:</b>
      </p>
      <ul>
        <li><b>Секция 1</b> – Перспективные синхротронные и нейтронные исследования</li>
        <li><b>Секция 2</b> – Научные результаты, полученные на экспериментальных станциях Курчатовского комплекса синхротронно-нейтронных исследований</li>
        <li class="ml-5"><i>Подсекция 2.1</i> – Материаловедение</li>
        <li class="ml-5"><i>Подсекция 2.2</i> – Биология и науки о жизни</li>
        <li class="ml-5"><i>Подсекция 2.3</i> – Культурное наследие</li>
        <li><b>Секция 3</b> – Концепция и научная программа синхротронно-лазерного комплекса «СИЛА»</li>
        <li class="ml-5"><i>Подсекция 3.1</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди источника СИ</li>
        <li class="ml-5"><i>Подсекция 3.2</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди лазера на свободных электронах</li>
        <li><b>Микросимпозиум 1</b> – Разработка научной программы развития нейтронных исследований в Российской Федерации</li>
        <li><b>Микросимпозиум 2</b> – Научная программы проектов «РИФ» и ТНК «Зеленоград»</li>
        <li><b>Круглый стол</b> – Промышленное применение установок мегакласса</li>
        <li><b>Круглый стол</b> – Совместная подготовка кадров  для развития синхротронных и нейтронных исследований</li>
      </ul>

      <p class="mt-2">
        Также в рамках Совещания пользователей запланировано проведение <b>круглого стола</b> «Программа развития исследовательских возможностей Курчатовского комплекса синхротронно-нейтронных исследований»
      </p> -->


        <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">
          <div style="margin-left: 20px;">
            <v-tabs v-model="activeTab" centered>
              <v-tab :key="1">21 окт. (понедельник)</v-tab>
              <v-tab :key="2">22 окт. (вторник)</v-tab>
              <v-tab :key="3">23 окт. (среда)</v-tab>
            </v-tabs>
          </div>
        </v-card-title>

        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="1">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Регистрация участников и гостей Форума</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл первого этажа Дома ученых</b>
                </div>
                <b class="prog-text">Приветственный кофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:00 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Пленарная сессия «Биоэкономика» </b>
                <br>
                <b class="prog-text ml-6" style="font-size: 16px;">Модератор: Ковальчук Михаил Валентинович,</b>
                <br>
                <b class="prog-text ml-6" style="font-size: 16px;">Президент НИЦ «Курчатовский институт»</b>
                <br>
                <!-- <p class="prog-text ml-6">Модератор: Ковальчук М.В., Президент НИЦ «Курчатовский институт»</p>
                <br> -->
                <!-- <b class="prog-text" style="font-size: 14px;">Подписание соглашений о сотрудничестве</b> -->
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>

            <hr>
            <v-row>
                  <v-col lg="6">
                      <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">14:00 - 18:00</b>
                        </v-chip>
                      </div>
                      <b class="prog-text" style="font-size: 16px;">Экскурсия в НИЦ "Курчатовский институт"</b>
                      <p class="prog-text ml-6 mb-0">(по предварительной записи)</p>
                      <div style="text-align: right;">
                        <b style="font-style: italic; color: gray;">территория Центра</b>
                      </div>

                  </v-col>
                  <v-col lg="6">
                      <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">14:00 - 17:00</b>
                        </v-chip>
                      </div>

                      <b class="prog-text" style="font-size: 16px;">Школа пользователей Курчатовского комплекса синхротронно-нейтронных исследований</b>
                      <p class="prog-text ml-6 mb-0">Модератор: Чубова Н.М.</p>
                      <div style="text-align: right;">
                        <b style="font-style: italic; color: gray;">Театральная студия</b>
                      </div>
                  </v-col>

            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:00 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Работа выставки Политехнического музея</b>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip color="#ae24c3" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 17:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Молодежная научная школа </b>
                <br>
                <b class="prog-text" style="font-size: 16px;">«Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия» </b>
                <br>
                <p class="prog-text ml-6 mb-1">Модератор: Григорьев Т.Е.</p>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:200px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 210">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 190: Коворкинг</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <hr>

            <v-row class="mt-3">
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 10:45</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Лекция «Будущее синхротронных и нейтронных исследований» </b>
                <br>
                <p class="prog-text ml-6 mb-1">Благов А.Е.</p>
                <!-- <v-btn 
                  small 
                  class='pa-2'
                  style="width:200px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 1">подробнее
                </v-btn> -->
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:45 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Лекция «КИСИ-Курчатов – 25 лет на службе науке»</b>
                <br>
                <p class="prog-text ml-6 mb-1">Марченков Н.В.</p>
                <!-- <v-btn 
                  small 
                  class='pa-2'
                  style="width:200px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 1">подробнее
                </v-btn> -->
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                </div>
              </v-col>
            </v-row>

            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Кофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">здание 348: ауд. 2017</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:00 - 13:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 16px;">Панельная дискуссия «Научная программа сети национальных мегаустановок РФ» </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Модератор: Марченков Н.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:200px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 212">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                    </div>
                  </v-col>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Авилов А.С.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 931">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
                  </v-col>
                </v-row>
                  
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:30 - 14:20</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Обед</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">здание 111, столовая</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col lg="6">
                <div  style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:20 - 16:00</b>
                  </v-chip>
                </div>

                <b class="prog-text" style="font-size: 14px;">Панельная дискуссия: </b>
                <b class="prog-text" style="font-size: 16px;">«Феномен «СИЛА» - в наукоемкой экономике России»</b>
                <br>
                <p class="prog-text ml-6 mb-1">Модератор: Пресняков М.Ю.</p>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 214">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                </div>
              </v-col>
              <v-col lg="6">
                <div  style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:30 - 16:30</b>
                  </v-chip>
                </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Васильев А.Л.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 932">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:00 - 17:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Постерная сессия совмещенная с Kофе-брейком</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">здание 348: ауд. 2017</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:00 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Круглый стол с приглашёнными докладами: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронное излучение для задач микроэлектроники: от нанометрологии до литографии»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Якунин С.Н.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 218">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Президентский зал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Панельная дискуссия </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования: вектор на технологическое лидерство»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Марченков Н.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 217">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Якимов Е.Б.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 933">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="3">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip color="#ae24c3" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b @click="goto_daria()" class="prog-text" style="font-size: 14px; cursor: pointer; color:#ae24c3;">VI молодежная конференция </b>
                <br>
                <b @click="goto_daria()" class="prog-text" style="font-size: 16px; cursor: pointer; color:#ae24c3;">«Проект DARIA: Компактные источники нейтронов в России»</b>
                <br>
                <p class="prog-text ml-6">Модератор: Кулевой Т.В.</p>

                <v-btn 
                  small 
                  class='pa-2'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 301">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 348: помещение 322</b>
                </div>
              </v-col>
            </v-row>
            <hr>

            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip color="#ae24c3" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 16:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Молодежная научная школа </b>
                <br>
                <b class="prog-text" style="font-size: 16px;">«Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия» </b>
                <br>
                <p class="prog-text ml-6 mb-1">Модератор: Григорьев Т.Е.</p>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:200px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 310">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 190: Коворкинг</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <hr>

            <v-row class="mt-3">
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 12:15</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 14px;">Секция 4: </b>
                    <b class="prog-text" style="font-size: 16px;">«Аппаратно-методические аспекты  синхротронных и нейтронных экспериментов»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Рогачев А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 334">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Президентский зал»</b>
                    </div>
                  </v-col>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Боргардт Н.И.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 934">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 12:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">здание 348: ауд. 2017</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
                  <v-col lg="4">
                      <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">12:00 - 14:00</b>
                        </v-chip>
                      </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронное излучение и нейтроны в материаловедении»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Чумаков Р.Г.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 311">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">12:30 - 14:00</b>
                        </v-chip>
                      </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 2: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронное излучение и нейтроны для биологии и наук о жизни»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Коневега А.Л.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 321">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Президентский зал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">12:00 - 13:30</b>
                        </v-chip>
                      </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Васильев А.Л.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 935">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
                  </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:30 - 15:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Обед</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">здание 111, столовая</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
                  <v-col lg="4">
                    <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">15:00 - 16:30</b>
                        </v-chip>
                      </div>

                    <b class="prog-text" style="font-size: 14px;">Секция 1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронное излучение и нейтроны в материаловедении»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Белушкин А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 312">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">14:30 - 16:00</b>
                        </v-chip>
                      </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 2: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронное излучение и нейтроны для биологии и наук о жизни»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Марченкова М.А.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 322">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 348: «Президентский зал»</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <div  style="max-width: 150px !important;">
                        <v-chip :color="$mainColor" text-color="white">
                          <v-avatar left>
                            <v-icon color="white">mdi-clock-time-eight</v-icon>
                          </v-avatar>
                          <b style="color:white;">14:30 - 16:15</b>
                        </v-chip>
                      </div>
                    <b class="prog-text" style="font-size: 14px;">Секция 3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Электронная микроскопия»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Авилов А.С.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 936">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Здание 140: Зал для конференций</b>
                    </div>
                  </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:00 - 17:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Постерная сессия совмещенная с Kофе-брейком</b>
                <v-btn 
                  small 
                  class='pa-2 ml-5'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 316">подробнее
                </v-btn>
                <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">2 этаж зд.348, ауд. 2017</b>
                    </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:30 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Закрытие форума</b>
                <!-- <v-btn 
                  small 
                  class='pa-2 ml-5'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 39">подробнее
                </v-btn> -->
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Здание 348: «Кинозал»</b>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>


    <v-dialog v-model="details_modal" max-width="60%">
      <v-card class="pa-2">
        <div v-if="details_type == 212">
          <v-card-title class="headline">
            <p>НАУЧНАЯ ПРОГРАММА СЕТИ НАЦИОНАЛЬНЫХ МЕГАУСТАНОВОК РФ</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_212">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 214">
          <v-card-title class="headline">
            <p>ФЕНОМЕН «СИЛА» В НАУКОЕМКОЙ ЭКОНОМИКЕ РОССИИ</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_214">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <div v-if="item.id == 3">
                    <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>Пестов Алексей Евгеньевич</b></p>
                    <p class="prog-text ml-12" style="font-size: 14px;">заведующий лабораторией 8133 Института физики микроструктур РАН</p>
                    <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>Елизаров Сергей Георгиевич</b></p>
                    <p class="prog-text ml-12" style="font-size: 14px;">генеральный директор ООО «ЦИФ МГУ им. М.В. Ломоносова»</p>
                  </div>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 217">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ:</p>
            <p>ВЕКТОР НА ТЕХНОЛОГИЧЕСКОЕ ЛИДЕРСТВО</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_217">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <!-- <div v-if="item.id == 8">
                    <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>Сорокин Павел Павлович</b></p>
                    <p class="prog-text ml-12" style="font-size: 14px;">Руководитель программы Блока экспертизы и функционального развития, Газпромнефть</p>
                  </div> -->
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 218">
          <v-card-title class="headline">
            <p>Синхротронное излучение для задач микроэлектроники:</p>
            <p>от нанометрологии до литографии</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_218">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 931">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 932">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 933">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_3">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 934">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_4">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 935">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_5">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 936">
          <v-card-title class="headline">
            <p>Электронная микроскопия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_6">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 334">
          <v-card-title class="headline">
            <p>Аппаратно-методические аспекты синхротронных и нейтронных экспериментов</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s4">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 301">
          <v-card-title class="headline">
            <p>VI молодежная конференция</p>
            <p>«Проект DARIA: Компактные источники нейтронов в России»</p>
            <v-btn 
                  small 
                  class='pa-2'
                  color="red" 
                  outlined
                  @click="goto_daria()">подробная информация на сайте конференции
                </v-btn>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_daria">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 311">
          <v-card-title class="headline">
            <p>Синхротронное излучение и нейтроны в материаловедении</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s1_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 312">
          <v-card-title class="headline">
            <p>Синхротронное излучение и нейтроны в материаловедении</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s1_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 321">
          <v-card-title class="headline">
            <p>Синхротронное излучение и нейтроны для биологии и наук о жизни</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s2_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 322">
          <v-card-title class="headline">
            <p>Синхротронное излучение и нейтроны для биологии и наук о жизни</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s2_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">{{  item.time }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;" v-if="item.header"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 210">
          <v-card-title class="headline">
            <p>Молодежная научная школа (22 октября)</p>
            <p>Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_210">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 310">
          <v-card-title class="headline">
            <p>Молодежная научная школа (23 октября)</p>
            <p>Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия</p>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_310">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white" v-if="item.time">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 316">
          <v-card-title class="headline">
            <p>Постерная сессия 2</p>
          </v-card-title>
          <v-card-text>
            <p class="prog-text ml-6 mb-0" style="font-size: 18px; color:#ae24c3;"><b>Секция 2. «Синхротронное излучение и нейтроны для биологии и наук о жизни»</b></p>
            <div v-for="item in details_p2_s2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <!-- <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar> -->
                    <b style="color:white;">{{  item.num }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.fio }}</b></p>
                  <!-- <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p> -->
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <p class="prog-text ml-6 mb-0" style="font-size: 18px; color:#ae24c3;"><b>Секция 1: СИ и нейтроны для материаловедения</b></p>
            <div v-for="item in details_p2_s1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <!-- <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar> -->
                    <b style="color:white;">{{  item.num }}</b>
                  </v-chip>
                </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.fio }}</b></p>
                  <!-- <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p> -->
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="details_modal = false">закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>
<script>

export default {
  name: 'Program_24',

  data() {
    return {
      activeTab: 0,
      details_modal: false,
      details_type: 0,

      items_26: [
        {id: 	1	, descr: '	Алексеев Роман Олегович'	, stend: '	104'	, st_name: '	Строение высокопреломляющих оксидных стекол по данным спектроскопии EXAFS и XANES'	},
        {id: 	2	, descr: '	Асадчиков В.Е.'	, stend: '	119'	, st_name: '	Рентгеновская рефлектометрия липидных плёнок на жидкостях с использованием синхротронного излучения'},
        {id: 	3	, descr: '	Баулин Роман Алексеевич'	, stend: '	128	', st_name: '	Кластерно-слоистая структура в пленках [Fe/Cr], выявленная методом GISAXS и синхротронной мёссбауэровской спектроскопии'	},
        {id: 	4	, descr: '	Бойков Николай Игоревич'	, stend: '	85'	, st_name: '	Синхротронные исследования эпитаксиальных структур олово-кремний'	},
        {id: 	5	, descr: '	Васильев Вениамин Андреевич'	, stend: '	125'	, st_name: '	Исследование зависимости откручивания ДНК от нуклеосом в зависимости от последовательности и длины ДНК методом малоуглового рассеяния рентгеновского излучения.'	},
        {id: 	6	, descr: '	Волков Ю. О.'	, stend: '	118'	, st_name: 'Структура адсорбционных плёнок алканолов на границе масло-вода по данным синхротронной рентгеновской рефлектометрии'	},
        {id: 	7	, descr: '	Голубничий Александр Александрович'	, stend: '	102'	, st_name: '	Кристаллическая структура магний-замещенных слоистых оксидов лития и переходных металлов'	},
        {id: 	8	, descr: '	Еремина Рушана Михайловна'	, stend: '	79'	, st_name: '	Магнитная структура монокристаллов (Ni,Mn,Cu)3BO5'	},
        {id: 	9	, descr: '	Ермакова Александра Михайловна'	, stend: '	105'	, st_name: '	Синтез и структурные особенности сегнетоэлектрических материалов по данным рентгеновской спектроскопии'	},
        {id: 	10	, descr: '	Кравченко Галина Валерьевна'	, stend: '	86'	, st_name: '	Влияние локального окружения ионов титана на каталитические свойства титансодержащих цеолитов типа MFI'	},
        {id: 	11	, descr: '	Крот Анна Дмитриевна'	, stend: '	84'	, st_name: '	Спектроскопия рентгеновского поглощения в исследовании физико-химических форм урана'	},
        {id: 	12	, descr: '	Кузенкова Анастасия Сергеевна'	, stend: '	92'	, st_name: '	Окислительно-восстановительное поведение Pu(VI) и Pu(V) в водных растворах'	},
        {id: 	13	, descr: '	Куликова Елизавета Сергеевна'	, stend: '	114'	, st_name: '	Порошковая дифракция высокого разрешения на станции «Белок/РСА» Курчатовского источника синхротронного излучения'	},
        {id: 	14	, descr: '	Макарова Ирина Павловна'	, stend: '	100'	, st_name: '	Исследование структуры кристаллов-суперпротоников	'},
        {id: 	15	, descr: '	Матюхов Владимир Владимирович'	, stend: '	93'	, st_name: '	Синтез углеродных покрытий на наночастицах металлов'	},
        {id: 	16	, descr: '	Моисеев Иван Алексеевич'	, stend: '	103'	, st_name: '	Кристаллическая структура магний-замещенных слоистых оксидов лития и переходных металлов'	},
        {id: 	17	, descr: '	Мусатова Вероника Юрьевна'	, stend: '	110', st_name: '	Функциональные магнитоактивные металлополимерные кобальт-, никель- и железосодержащие наноматериалы, синтезированные из ненасыщенных дикарбоксилатов'	},
        {id: 	18	, descr: '	Муфтахова Лия Рустемовна'	, stend: '	131'	, st_name: '	Двумерная сверхструктура плёнки арахиновой кислоты с комплексами церия на поверхности раствора нитрата церия'	},
        {id: 	19	, descr: '	Недоедкова Ольга Вадимовна'	, stend: '	98'	, st_name: '	Изменение проводящей структуры полианилина при допировании переходными металлами'	},
        {id: 	20	, descr: '	Новичков Даниил Андреевич', stend: '	115'	, st_name: '	Спектроскопия рентгеновского поглощения в лаборатории и на синхротроне: преимущества и недостатки'	},
        {id: 	21	, descr: '	Нуретдинов Тагир Мансурович'	, stend: '	108	', st_name: '	Топологические электронные переходы в киральных ферромагнетиках FеMnSi c кубической структурой без центра инверсии'	},
        {id: 	22	, descr: '	Огаркова Надежда Константиновна'	, stend: '	97'	, st_name: '	Синтез биметаллического комплекса [PtPy2(FcCOO)2] и исследование методом EXAFS продуктов его термораспада — предшественников каталитически активных функциональных наноматериалов'	},
        {id: 	23	, descr: '	Павлов Константин Андреевич' , stend: '	129	', st_name: '	Численное моделирование установки малоуглового рассеяния нейтронов для компактного нейтронного источника'	},
        {id: 	24	, descr: '	Пелагина Александра Константиновна'	, stend: '	87'	, st_name: '	Синхротронные исследования структур нитевидного кремния	'},
        {id: 	25	, descr: '	Полякова Татьяна Романовна'	, stend: '	88'	, st_name: '	Определение валентного состояния урана с использованием XANES спектроскопии для прогноза миграции техногенного урана в условиях окружающей среды'	},
        {id: 	26	, descr: '	Постников Михаил Сергеевич'	, stend: '	109'	, st_name: '	Термическая устойчивость CuZrSe2 и CuCrSe2'	},
        {id: 	27	, descr: '	Рубцова Елизавета Дмитриевна'	, stend: '	89'	, st_name: '	Композитные материалы на основе алмаза для детектирования ионизирующего излучения'	},
        {id: 	28	, descr: '	Садыков Равиль Асхатович'	, stend: '	80'	, st_name: '	Нейтронография магнитной спирали монокристалла гексаферрита BaCo2Ti2Fe8O19 типа М в сильном магнитном поле'	},
        {id: 	29	, descr: '	Серов Егор Олегович	', stend: '	81'	, st_name: '	Разработка экспериментального стенда для получения поляризованных  нейтронов на реакторе ИР-8'},
        {id: 	30	, descr: '	Снегирёв Никита Игоревич'	, stend: '	113'	, st_name: '	Рентгеновская диагностика монокристаллических материалов в условиях воздействия внешнего магнитного поля'	},
        {id: 	31	, descr: '	Старостин Леонид Юрьевич'	, stend: '	94'	, st_name: '	Изучение строения комплексов f-элементов с полидентантными N, O –донорными гетероциклическими лигандами, методами EXAFS и ЯМР.	'},
        {id: 	32	, descr: '	Стегайлов Владимир Ильич'	, stend: '	101'	, st_name: '	Исследование продуктов реакций в мишенях висмута,урана и актинидов на ускорителях протонов и электронов с энергиями (Ep=660 Мэв) и (Ee=180 Мэв).	'},
        {id: 	33	, descr: '	Сулимова Олеся Витальевна'	, stend: '	96'	, st_name: '	Синтез гетерометаллического комплекса платины, исследование его термических превращений и каталитические свойства полученного нанесенного катализатора Pt/Zn/Al2O3	'},
        {id: 	34	, descr: '	Таланов Михаил Валерьевич' , stend: '	107'	, st_name: '	Возможности современных теоретико-групповыхметодов в решении кристаллографических задач теории фазовых переходов	'},
        {id: 	35	, descr: '	Ташметов Маннаб Юсупович'	, stend: '	83'	, st_name: '	Исследование объектов культурного наследия на установке нейтронной радиографии и томографии ИЯФ АН РУз	'},
        {id: 	36	, descr: '	Тетерин Юрий Александрович'	, stend: '	99'	, st_name: '	Применение синхротронных методов для изучения структуры смешанных карбонатов Np(V) '	},
        {id: 	37	, descr: '	Титова София Сергеевна'	, stend: '	90'	, st_name: '	Синхротронные исследования для оптимизации процесса формирования нано-био-гибридных структур и комплексов на основе наночастиц пористого кремния.'	},
        {id: 	38	, descr: '	Толчина Дарья Борисовна'	, stend: '	106'	, st_name: '	Атомное и электронное строение допированных азотом кластеров нано-графена по данным комбинированного анализа методами XPS и XANES '	},
        {id: 	39	, descr: '	Фатеев Кирилл Александрович'	, stend: '	91'	, st_name: '	Особенности атомного и электронного строения нитевидных кристаллов SnO2 по данным синхротронных исследований'	},
        {id: 	40	, descr: '	Шкварин Алексей Сергеевич	', stend: '	111'	, st_name: '	Влияние окта и тетра заполнения на электронную структуру в CuxZrSe2 и CrxZrSe2'	},
        {id: 	41	, descr: '	Шуленина Александра Владимировна'	, stend: '	82'	, st_name: '	Анализ агрегационного состояния магнитных жидкостей на основе анизотропного малоуглового рассеяния рентгеновских лучей.'	},
        {id: 	42	, descr: '	Яловега Галина Эдуардовна'	, stend: '	95'	, st_name: '	Влияние межфазных взаимодействий в системе NiOx-графеновая плоскость на формирование проводящей структуры в гибридных нанокомпозитных материалах для суперконденсаторов'},
        {id: 	43	, descr: '	Янжимаев Борис Юрьевич'	, stend: '	124'	, st_name: '	Синтез и свойства Mo- и W-содержащих катализаторов на основе цеолита со структурой MFI	'},
      ],
      
      details_210: [
        {
          id: 1,
          time: '10:00 - 11:30',
          header: 'Экскурсия на объекты научной инфраструктуры НИЦ «Курчатовский институт»',
          subheader: 'Курчатовский специализированный источник синхротронного излучения  «КИСИ-Курчатов», ресурсные центры',
          main: '',
        },
        {
          id: 2,
          time: '11:40 - 12:00',
          header: 'Кофе-пауза',
          subheader: '',
          main: '',
        },
        {
          id: 3,
          time: '12:05 - 12:15',
          header: 'Т.Е. Григорьев',
          subheader: 'НИЦ «Курчатовский институт»',
          main: 'Приветственное слово',
        },
        {
          id: 4,
          time: '12:15 - 13:00',
          header: 'Е.Б. Яцишина',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Итоги проекта «Комплексные исследования объектов культурного наследия с использованием рентгеновского и синхротронного излучения, нейтронов и электронов» (СиН-КН)»',
        },
        {
          id: 5,
          time: '13:00 - 13:45',
          header: 'А.В. Белушкин',
          subheader: 'НИЦ «Курчатовский институт», ОИЯИ',
          main: '«Источники нейтронов, методы нейтронной диагностики в изучении культурного наследия»',
        },
        {
          id: 6,
          time: '13:45 - 14:45',
          header: 'Обед',
          subheader: '',
          main: '',
        },
        {
          id: 7,
          time: '14:45 - 15:30',
          header: 'И.А. Сапрыкина',
          subheader: 'Институт археологии РАН',
          main: '«Современные методы аналитических исследований археологических находок»',
        },
        {
          id: 8,
          time: '15:30 - 16:15',
          header: 'Ф.С. Шарко',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Развитие палеогеномики в Курчатовском институте»',
        },
        {
          id: 9,
          time: '16:15 - 17:30',
          header: 'Кофе-пауза',
          subheader: '',
          main: '',
        },
      ],

      details_310: [
      {
          id: 1,
          time: '10:00 - 10:45',
          header: 'Е.О. Мирошина',
          subheader: 'РГХПУ им. С.Г. Строганова',
          main: '«История реставрации и сохранения культурных ценностей с древних времен и до наших дней»',
        },
        {
          id: 2,
          time: '12:05 - 12:15',
          header: 'М.В. Добровольская',
          subheader: 'Институт археологии РАН',
          main: '«Естественно-научные исследования органических объектов культурного наследия»',
        },
        {
          id: 3,
          time: '11:30 - 12:00',
          header: 'Кофе-пауза',
          subheader: '',
          main: '',
        },
        {
          id: 4,
          time: '12:00 - 12:45',
          header: 'Н.И. Шишлина',
          subheader: 'Государственный исторический музей',
          main: 'Древний текстиль и его физико-химические исследования',
        },
        {
          id: 5,
          time: '12:45 - 13:30',
          header: 'П.И. Калинин',
          subheader: 'Институт Физико-Химических и Биологических Проблем Почвоведения РАН',
          main: '«Археологическое почвоведение»',
        },
        {
          id: 6,
          time: '13:30 - 14:30',
          header: 'Обед',
          subheader: '',
          main: '',
        },
        {
          id: 7,
          time: '14:30 - 15:15',
          header: 'Е.Ю. Терещенко',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Методология комплексного подхода к изучению объектов культурного наследия»',
        },
        {
          id: 8,
          time: '15:15 - 16:30',
          header: 'А.В. Антипенко',
          subheader: 'Институт археологии Крыма РАН',
          main: '«Технологии средневековых городов Крыма по данным естественно-научных исследований»',
        },
      ],

      details_212: [
        // {
        //   id: 1,
        //   time: '12:00 - 12:10',
        //   header: 'Благов Александр Евгеньевич',
        //   subheader: 'вице-президент НИЦ «Курчатовский институт»',
        //   main: '«О новой СНТР, приоритетах научно-технологического развития и важности установок мегакласса в НТР, о единой программе синхротронных и нейтронных исследований в РФ»',
        // },
        // {
        //   id: 2,
        //   time: '12:10 - 12:19',
        //   header: 'Марченков Никита Владимирович',
        //   subheader: 'руководитель Курчатовского комплекса синхротронно-нейтронных исследований НИЦ «Курчатовский институт»',
        //   main: '«О научной программе КИСИ-Курчатов после модернизации и грантовой Программе Минобрнауки в рамках ППРФ №951»',
        // },
        {
          id: 3,
          // time: '12:19 - 12:28',
          header: 'Белушкин Александр Владиславович',
          subheader: 'заместитель руководителя Курчатовского комплекса синхротронно-нейтронных исследований по научной работе НИЦ «Курчатовский институт», начальник отделения нейтронных исследований и разработок в области конденсированных сред, ЛНФ, ОИЯИ',
          main: '«Научная программа развития нейтронных исследований в РФ включая ИБР-2 и ИР-8»',
        },
        {
          id: 4,
          // time: '12:28 - 12:37',
          header: 'Воронин Владимир Владимирович',
          subheader: 'заместитель директора по научным вопросам НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Научная программа ПИК»',
        },
        {
          id: 5,
          // time: '12:37 - 12:46',
          header: 'Бухтияров Валерий Иванович',
          subheader: 'директор ИК СО РАН',
          main: '«О научной программе СКИФ»',
        },
        {
          id: 6,
          // time: '12:46 - 12:55',
          header: 'Звонарев Сергей Владимирович',
          subheader: 'Директор Дальневосточного центра синхротронных исследований, ДВФУ',
          main: '«Научная программа РИФ»',
        },
        {
          id: 7,
          // time: '12:55 - 13:04',
          header: 'Якунин Сергей Николаевич',
          subheader: 'первый заместитель руководителя Курчатовского комплекса синхротронно-нейтронных исследований НИЦ «Курчатовский институт»',
          main: '«О научно-производственной программе ТНК «Зеленоград»»',
        },
        {
          id: 8,
          // time: '13:04 - 13:13',
          header: 'Пресняков Михаил Юрьевич',
          subheader: 'начальник УСИУ «СИЛА»',
          main: '«О научной программе СИЛА»',
        },
        {
          id: 9,
          // time: '13:13 - 13:22',
          header: 'Егорычев Виктор Юрьевич',
          subheader: 'директор НИЦ «Курчатовский институт»-ИФВЭ',
          main: '«О программе развития фундаментальных исследований в РФ и роли ускорителей в ее реализации»',
        },
        {
          id: 10,
          // time: '13:22 - 13:30',
          header: 'Заключение модератора, подведение итогов сессии',
          subheader: '',
          main: '',
        },

      ],
      
      details_p2_s1: [
        {
          id: 1,
          num: 'C101',
          fio: 'Акимова Ольга Владимировна',
          main: '«Исследование структуры функциональных сплавов на основе палладия»',
        },
        {
          id: 1,
          num: 'C102',
          fio: 'Амарантов Сергей Владимирович',
          main: '«Определение параметров нанокомпазитов через модель "ядро-оболочка" методом рентгеновского малоуглового рассеяния»',
        },
        {
          id: 1,
          num: 'C103',
          fio: 'Антипенко Анна Витальевна',
          main: '«Комплексный подход к изучению археологических находок и предметов музейных коллекций из цветного и драгоценного металла»',
        },
        {
          id: 1,
          num: 'C104',
          fio: 'Арбанас Левко Андреевич',
          main: '«Состав и строение кристаллов и растворов NiSO4·6H2O:Co. Дифракционные и комплементарные методы»',
        },
        {
          id: 1,
          num: 'C155',
          fio: 'Бакиров Булат Айратович',
          main: '«Реконструкция трехмерных моделей артефактов некрополя Волна-1 из данных нейтронной томографии»',
        },
        {
          id: 1,
          num: 'C105',
          fio: 'Беляева Анна Олеговна',
          main: '«Особенности микроструктуры тонких пленок ортоферрита иттрия на сапфире»',
        },
        {
          id: 1,
          num: 'C106',
          fio: 'Благов Максим Андреевич',
          main: '«Первая кристаллическая структура анионного комплекса Fe(III) на основе тиосемикарбазона пировиноградной кислоты с катионом лития»',
        },
        {
          id: 1,
          num: 'C107',
          fio: 'Блинникова Дарья Андреевна',
          main: '«Stimuli-responsive координационные полимеры на основе пентафторпропионатов РЗЭ: синтез, структура, свойства»',
        },
        {
          id: 1,
          num: 'С112',
          fio: 'Борисова Полина Алексеевна',
          main: '«Влияние легирующих карбидообразующих и не карбидообразующих элементов на фазовые превращения фуллеренов С60 при высоких давлениях и температурах»',
        },
        {
          id: 1,
          num: 'C108',
          fio: 'Гаас Вячеслав Александрович',
          main: '«Сравнительное исследование атомно-электронной структуры координационных узлов в молекулярных комплексах [М(Salen)] (M=Co, Ni, Cu) по данным рентгеновской абсорбционной спектроскопии»',
        },
        {
          id: 1,
          num: 'C109',
          fio: 'Гладченко-Джевелекис Янис Николаевич',
          main: '«Методика определения структуры медных центров Cu-MOR на основе компьютерного моделирования с элементами машинного обучения»',
        },
        {
          id: 1,
          num: 'C110',
          fio: 'Ильин Александр Иванович',
          main: '«Вариации распределения элементного состава по толщине тонких плёнок YBaCuO, полученных импульсным лазерным осаждением из одной мишени»',
        },
        {
          id: 1,
          num: 'C153',
          fio: 'Калоян Александр Альбертович',
          main: '«Исследование структурного совершенства синтетических монокристаллов алмаза применяемых в качестве рентгенооптических элементов»',
        },
        {
          id: 1,
          num: 'C113',
          fio: 'Копица Геннадий Петрович',
          main: '«МЕЗОСТРУКТУРА ВЫСОКОПОРИСТОГО КРЕМНЕЗЕМА, ПОЛУЧЕННОГО ПУТЕМ ПИРОЛИЗА СИЛИКАТНО-ПОЛИМЕРНЫХ КОМПОЗИТОВ»',
        },
        {
          id: 1,
          num: 'C114',
          fio: 'Крот Анна Дмитриевна',
          main: '«Локальная структура комплексов уранил-катиона, сорбированного на глинистых минералах»',
        },
        {
          id: 1,
          num: 'C115',
          fio: 'Лихачев Игорь Александрович',
          main: '«Влияние кристаллической структуры тонких слоёв гидридов гадолиния в периодических системах Fe/GdHx на их магнитные свойства»',
        },
        {
          id: 1,
          num: 'C116',
          fio: 'Лобач Анатолий Степанович',
          main: '«ПЛЕНОЧНЫЕ ГИБРИДНЫЕ МАТЕРИАЛЫ НА ОСНОВЕ НАНОЛИСТОВ ОКСИДА ГРАФЕНА И СПИН-ПЕРЕМЕННОЙ СОЛИ [Et4N][FeIII(5Cl-thsa)2]»',
        },
        {
          id: 1,
          num: 'C117',
          fio: 'Лушников Степан Александрович',
          main: '«Изменение объема решетки легированных интерметаллических соединений при взаимодействии с водородом»',
        },
        {
          id: 1,
          num: 'C118',
          fio: 'Максимов Павел Александрович',
          main: '«Китаевское взаимодействие в цепочках ионов Co2+ в пироксене SrCoGe2O6»',
        },
        {
          id: 1,
          num: 'С111',
          fio: 'Манько Иван Денисович',
          main: '«КИРАЛЬНЫЙ СПИНОВЫЙ БЛИЖНИЙ ПОРЯДОК И ОСОБЕННОСТИ МАЛОУГЛОВОГО РАССЕЯНИЯ НЕЙТРОНОВ В ГЕЛИКОИДАЛЬНЫХ ФЕРРОМАГНЕТИКАХ С НЕЦЕНТРОСИММЕТРИЧНОЙ КУБИЧЕСКОЙ СТРУКТУРОЙ (НА ПРИМЕРЕ MnSi)»',
        },
        {
          id: 1,
          num: 'C119',
          fio: 'Матвеев Василий Александрович',
          main: '«Использование методов рентгеновской рефлектометрии и дифракции в скользящей геометрии для исследования тонких пленок допированных наночастицами металлов платиновой группы»',
        },
        {
          id: 1,
          num: 'C120',
          fio: 'Матвеева Анна Николаевна',
          main: '«Механизм магнетосопротивления в двуслойном манганите лантана  La1.4Sr1.6Mn0.9Co0.1O7»',
        },
        {
          id: 1,
          num: 'C121',
          fio: 'Матвеева Анна Николаевна',
          main: '«Магнитное упорядочение и киральность в мультиферроике DyMnO3»',
        },
        {
          id: 1,
          num: 'C122',
          fio: 'Меншарапов Руслан Максимович',
          main: '«Исследование влияния отрицательных температур на структуру модифицированных SiO2 мембран Nafion® методом малоуглового рентгеновского рассеяния»',
        },
        {
          id: 1,
          num: 'C123',
          fio: 'Мурашев Михаил Михайлович',
          main: '«Исследование концевых соединителей токонесущих элементов на основе ВТСП с помощью неразрушающих методов нейтронной визуализации»',
        },
        {
          id: 1,
          num: 'C124',
          fio: 'Муштаков Антон Георгиевич',
          main: '«Получение, состав и особенности строения монокристаллов металлоорганического полимера CuBTC типа HKUST-1»',
        },
        {
          id: 1,
          num: 'C125',
          fio: 'Назаров Афин Магомед оглы',
          main: '«Рост эпитаксиальных пленок Pb1-xMnxTe (Ga) на монокристаллах PbTe»',
        },
        {
          id: 1,
          num: 'C126',
          fio: 'Назаров Афин Магомед оглы',
          main: '«Процесс фазообразования в тонких пленках AgCuS»',
        },
        {
          id: 1,
          num: 'C127',
          fio: 'Назаров Афин Магомед оглы',
          main: '«Влияние атомов Ge на формирование аморфных пленок TlGaSe2»',
        },
        {
          id: 1,
          num: 'C128',
          fio: 'Назин Валерий Георгиевич',
          main: '«Исследования гадолиния методом спектроскопии  характеристических потерь энергии электронов»',
        },
        {
          id: 1,
          num: 'C129',
          fio: 'Понкратова Екатерина Юрьевна',
          main: '«Создание и исследование лазерно-индуцированных покрытий диоксида титана методами электронной микроскопии и рентгеновской фотоэлектронной спектроскопии для задач фотокатализа»',
        },
        {
          id: 1,
          num: 'C130',
          fio: 'Садыков Равиль Асхатович',
          main: '«Период магнитной спирали в шпинели 114 Cd0,3Zn0,7Cr2Se4 под давлением»',
        },
        {
          id: 1,
          num: 'C131',
          fio: 'Спиридонов Владислав Алексеевич',
          main: '«Исследование кислородных вакансий в монокристалле β-Ga2O3»',
        },
        {
          id: 1,
          num: 'C156',
          fio: 'Спицына Наталья Германовна',
          main: '«Биядерный комплекс Fe(III) – продукт электроокисления [FeIII(5Cl-thsa)2]-: синтез, кристаллическая структура»',
        },
        {
          id: 1,
          num: 'C132',
          fio: 'Срабионян Василий Валерьевич',
          main: '«Структура и оптические свойства центров серебра, сформированных в РZ-стекле до и после обработки ФС-лазером»',
        },
        {
          id: 1,
          num: 'C133',
          fio: 'Стегайлов Владимир Ильич',
          main: '«Исследования радиационных свойств материалов с помощью реакций мультифрагментации (энергия пучка более 1гэв/нуклон): графит, ленты втсп, тантал, висмут,золото, уран, торий, актиниды»',
        },
        {
          id: 1,
          num: 'C134',
          fio: 'Стегайлов Владимир Ильич',
          main: '«ИССЛЕДОВАНИЕ СВОЙСТВ ВЫСОКОСПИНОВЫХ ИЗОМЕРОВ В ОБЛАСТИ (N=88-89) В ЯДРАХ  ГОЛЬМИЯ И ЕВРОПИЯ МЕТОДАМИ ЯДЕРНОЙ И ЛАЗЕРНОЙ СПЕКТРОСКОПИИ В РАМКАХ ПРОГРАММЫ ИЗУЧЕНИЯ РАДИАЦИОННЫХ СВОЙСТВ МАТЕРИАЛОВ»',
        },
        {
          id: 1,
          num: 'C135',
          fio: 'Сульянова Елена Александровна',
          main: '«Методика моделирования дефектной структуры нестехиометрических флюоритовых фаз на примере α-Na0.35Dy0.65F2.30»',
        },
        {
          id: 1,
          num: 'C136',
          fio: 'Сульянова Елена Александровна',
          main: '«Дефектная кристаллическая структура α-Na0.5–xR0.5+xF2+2x (R = Dy–Lu, Y) по данным рентгеновской и электронной дифракции»',
        },
        {
          id: 1,
          num: 'C137',
          fio: 'Суханов Андрей Евгеньевич',
          main: '«Октамер, как трехмерный фрагмент формирования кристалла дигидрофосфата калия»',
        },
        {
          id: 1,
          num: 'C138',
          fio: 'Сухарина Галина Борисовна',
          main: '«Определение количественных параметров локальной атомной структуры стекол систем LNB и LTaB»',
        },
        {
          id: 1,
          num: 'C139',
          fio: 'Ткаченко Кирилл Юрьевич',
          main: '«Исследования мультиферроика TmFeO3 методами рентгеновской и нейтронной дифракции»',
        },
        {
          id: 1,
          num: 'C140',
          fio: 'Тригуб Александр Леонидович',
          main: '«Определение структуры комплексов Ag+ с аминогруппами в среде олигооксипропилендиамина методами EXAFS и XANES»',
        },
        {
          id: 1,
          num: 'C141',
          fio: 'Фараонов Максим Алексеевич',
          main: '«Кристаллическая структура, оптические и магнитные свойства координационных комплексов металлофталоцианинов»',
        },
        {
          id: 1,
          num: 'C142',
          fio: 'Халеменчук Вячеслав Павлович',
          main: '«Оснастка для исследования взрывных процессов во взрывной камере с использованием синхротронного излучения»',
        },
        {
          id: 1,
          num: 'C143',
          fio: 'Чареева Полина Владимировна',
          main: '«Зарядовое состояние Pt в бинарных соединениях»',
        },
        {
          id: 1,
          num: 'C144',
          fio: 'Черковский Евгений Николаевич',
          main: '«Моделирование атомных конфигураций на интерфейсе CeO2-Cu»',
        },
        {
          id: 1,
          num: 'C145',
          fio: 'Черноглазов Константин Юрьевич',
          main: '«Влияние состава наногранул на структурные и мемристивные свойства металл-диэлектрических композиов»',
        },
        {
          id: 1,
          num: 'C146',
          fio: 'Чувенкова Ольга Александровна',
          main: '«Синхротронные исследования электронного строения и состава тонких эпитаксиальных и магнетронных слоев оксида олова»',
        },
        {
          id: 1,
          num: 'C154',
          fio: 'Шамьюнов Камиль Маратович	',
          main: '«Анализ рентгеновских спектров марганца с использованием свёрточной нейронной сети»',
        },
        {
          id: 1,
          num: 'C147',
          fio: 'Шрамков Егор Александрович',
          main: '«Расшифровка фотоэлектронных спектров валентной зоны кластерных структур Ge(111), GeO2/Ge(111), C60F18/Ge(111), C60F18/GeO2/Ge(111)»',
        },
        {
          id: 1,
          num: 'C148',
          fio: 'Шубабко Ольга Эдуардовна',
          main: '«Структурные изменения в дисперсных порошках при механоактивации»',
        },
        {
          id: 1,
          num: 'C149',
          fio: 'Шуленина Александра Владимировна',
          main: '«АНАЛИЗ СТРУКТУРЫ НАНОСФЕР ФОТОННЫХ КРИСТАЛЛОВ ПО ДАННЫМ МАЛОУГЛОВОГО РАССЕЯНИЯ РЕНТГЕНОВСКИХ ЛУЧЕЙ»',
        },
        {
          id: 1,
          num: 'C150',
          fio: 'Шурыгин Антон Владимирович',
          main: '«Структура светотрансформирующих материалов на основе органических комплексов Yb(III) по данным EXAFS»',
        },
        {
          id: 1,
          num: 'C151',
          fio: 'Юрасова Ирина Игоревна',
          main: '«Результаты рентгеновского анализа образцов искусственного опала, синтезированного, при различных молярных соотношениях вода/ТЭОС в исходной смеси для выделения субглобулярной структуры наносфер»',
        },
        {
          id: 1,
          num: 'C152',
          fio: 'Якушев Илья Аркадьевич',
          main: '«Синтез и исследование каталитически активных биметаллических материалов на основе палладия и платины с применением рентгеновской спектроскопии EXAFS и XANES»',
        },
      ],

      details_p2_s2:[
        {
          id: 1,
          num: 'C201',
          fio: 'Гагиева Светлана Светлана	',
          main: '«Синтез и исследование катализаторов на основе новых комплексов титана (IV) с лигандами  OX-типов в реакции полимеризации олефинов»',
        },
        {
          id: 1,
          num: 'C202',
          fio: 'Гергележиу Полина Алексеевна',
          main: '«Особенности колебательных спектров ибупрофена по результатам комплексных исследований»',
        },
        {
          id: 1,
          num: 'C203',
          fio: 'Иванова Любовь Алексеевна',
          main: '«Пути формирования кристаллической и надмолекулярной структуры биоминералов СаСО3, осажденных B.cereus»',
        },
        {
          id: 1,
          num: 'C204',
          fio: 'Литвинов Михаил Юрьевич',
          main: '«Анализ структуры дисперсий (био)полиэлектролитных комплексов на основе хитозана и желатина с помощью малоуглового рентгеновского рассеяния синхротронного излучения»',
        },
        {
          id: 1,
          num: 'C205',
          fio: 'Малышева Наталия Евгеньевна',
          main: '«ИССЛЕДОВАНИЕ ВЗАИМОДЕЙСТВИЯ S-БЕЛКА С ИЗОЛИРОВАННЫМИ МОДЕЛЯМИ КЛЕТОЧНЫХ МЕМБРАН»',
        },
        {
          id: 1,
          num: 'C206',
          fio: 'Стрельникова Наталия Сергеевна',
          main: '«Определение относительной биологической эффективности в зависимости от ЛПЭ и дозы при облучении мышей протонами с энергией 100 МэВ»',
        },
        {
          id: 1,
          num: 'C207',
          fio: 'Табаров Артем Тимурович',
          main: '«Исследование инактивированных аденовирусов методом МУРР»',
        },
        {
          id: 1,
          num: 'C208',
          fio: 'Тимралиева Александра Акбулатовна',
          main: '«Широкоугольная дифракция для in situ мониторинга роста функциональных супрамолекулярных агрегатов в средах с высокой плотностью»',
        },
        {
          id: 1,
          num: 'C209',
          fio: 'Титова София Сергеевна',
          main: '«Влияние поверхностей, несущий пробу гибридного материала «клетки млекопитающих – наночастицы кремния» на исследования синхротронным методом рентгеновской фотоэлектронной спектроскопии»',
        },
        {
          id: 1,
          num: 'C210',
          fio: 'Швецов Алексей Валерьевич',
          main: '«Развитие методов анализа траекторий молекулярной динамики в программном пакете GROMACS»',
        },
        
      ],

      details_214: [
        {
          id: 1,
          time: '14:30 - 14:35',
          header: 'Пресняков Михаил Юрьевич',
          subheader: 'начальник управления по созданию исследовательской установки «СИЛА» НИЦ «Курчатовский институт»',
          main: '«О реализации проекта по созданию исследовательской установки «СИЛА»»',
        },
        {
          id: 2,
          time: '14:35 - 14:40',
          header: 'Якунин Сергей Николаевич',
          subheader: 'первый заместитель руководителя Курчатовского комплекса синхротронно-нейтронных исследований НИЦ «Курчатовский институт»',
          main: '«Синхротронное излучение для решения актуальных фундаментальных и прикладных научных задач»',
        },
        {
          id: 3,
          time: '14:40 - 15:10',
          header: 'Горностаев Дмитрий Андреевич',
          subheader: 'директор по развитию ООО «Адватекс»',
          main: '«Разработка элементов и систем экспериментальных станций источников синхротронного излучения»',
        },
        {
          id: 4,
          time: '15:10 - 15:20',
          header: 'Денисов Владимир Викторович',
          subheader: 'заведующий лабораторией пучково-плазменной инженерии поверхности Института сильноточной электроники СО РАН',
          main: '«Проектирование и создание оборудования для экспериментальных станций ЦКП «СКИФ»»',
        },
        {
          id: 5,
          time: '15:20 - 15:30',
          header: 'Тарасова Ольга Евгеньевна',
          subheader: 'директор АНО «Центр развития научных и образовательных инициатив»',
          main: '«Модели кооперации «наука, бизнес, образование»»',
        },
        {
          id: 6,
          time: '15:30 - 15:40',
          header: 'Бунчук Игорь Игоревич',
          subheader: 'заместитель генерального директора по информационным технологиям и автоматизации процессов производства АО «ЦПТИ»',
          main: '«Цифровые решения для обеспечения создания, эксплуатации и обслуживания уникальной научно-исследовательской инфраструктуры»',
        },
        {
          id: 7,
          time: '15:40 - 15:50',
          header: 'Демидов Михаил Евгеньевич',
          subheader: 'старший вице-президент ГК «Технотранс»',
          main: '«Разработка и внедрение операционных двойников сложных инфраструктурных объектов управления»',
        },
        {
          id: 8,
          time: '15:50 - 16:00',
          header: 'Царев Григорий Александрович',
          subheader: 'начальник отдела информационных технологий и автоматизации управления по созданию исследовательской установки «СИЛА» НИЦ «Курчатовский институт»',
          main: '«Разработка АСУ ТП ускорительно-накопительного комплекса исследовательской установки «СИЛА»»',
        },
        {
          id: 9,
          time: '16:00 - 16:10',
          header: 'Григорьев Тимофей Евгеньевич',
          subheader: 'заместитель руководителя Курчатовского комплекса НБИКС-природоподобных технологий НИЦ «Курчатовский институт»',
          main: '«Подготовка и повышение квалификации научных и инженерных кадров для создания и эксплуатации сети исследовательской инфраструктуры класса «мегасайенс»»',
        },
        {
          id: 10,
          time: '16:10 - 16:30',
          header: 'Заключение модератора, подведение итогов сессии',
          subheader: '',
          main: '',
        },
      ],
      details_217: [
        {
          id: 1,
          time: '17:00 - 17:10',
          header: 'Бухтияров Валерий Иванович',
          subheader: 'СО РАН',
          main: '«Научная программа СКИФ и применение СИ в химической промышленности»',
        },
        {
          id: 1,
          time: '17:10 - 17:20',
          header: 'Марченков Никита Владимирович',
          subheader: 'руководитель Курчатовского комплекса синхротронно-нейтронных исследований НИЦ «Курчатовский институт»',
          main: '«О новой СНТР, приоритетах научно-технологического развития, важнейших наукоемких технологиях»',
        },
        {
          id: 2,
          time: '17:20 - 17:30',
          header: 'Горбовец Михаил Александрович',
          subheader: 'начальник испытательного центра, НИЦ «Курчатовский институт» - ВИАМ',
          main: '«Конструкционные материалы»',
        },
        {
          id: 3,
          time: '17:30 - 17:40',
          header: 'Оганов Артем Ромаевич',
          subheader: 'руководитель лаборатории дизайна материалов, Сколтех',
          main: '«Дизайн новых материалов, получаемых, в том числе, в экстремальных условиях»',
        },
        {
          id: 4,
          time: '17:40 - 17:50',
          header: 'Турищев Сергей Юрьевич',
          subheader: 'заведующий кафедрой общей физики, Воронежский государственный университет',
          main: '«Синхротронная диагностика для микроэлектроники»',
        },
        {
          id: 5,
          time: '17:50 - 18:00',
          header: 'Шавкин Сергей Викторович',
          subheader: 'начальник отдела сверхпроводниковых, криогенных и магнитных технологий, НИЦ «Курчатовский институт»',
          main: '«Рентгеновские и нейтронные исследования для развития сверхпроводимости»',
        },
        {
          id: 6,
          time: '18:00 - 18:10',
          header: 'Самыгина Валерия Ролановна',
          subheader: 'начальник отдела структурной биологии Курчатовского комплекса НБИКС-природоподобных технологий, НИЦ «Курчатовский институт»',
          main: '«Исследования биологических объектов для медицины»',
        },
        {
          id: 7,
          time: '18:10 - 18:20',
          header: 'Яковлев Павел Андреевич',
          subheader: 'Заместитель генерального директора по ранней разработке и исследованиям биотехнологической компании, ЗАО BIOCAD',
          main: '«Использование информации об атомной структуре для разработки лекарственных препаратов»',
        },
        {
          id: 8,
          time: '18:20 - 18:30',
          header: 'Кадыров Раиль Илгизарович',
          subheader: 'Казанский федеральный университет. Институт геологии и нефтегазовых технологий ',
          main: '«Синхротронные исследования для нефтедобывающей отрасли»',
        },
        {
          id: 9,
          // time: '18:20 - 18:30',
          header: 'Заключение модератора, подведение итогов сессии',
          subheader: '',
          main: '',
        },
      ],

      details_218: [
        {
          id: 1,
          // time: '17:00 - 17:10',
          header: 'Полковников Владимир Николаевич',
          subheader: 'Институт физики микроструктур РАН',
          main: '«Новая концепция развития высокопроизводительной рентгеновской литографии»',
        },
        {
          id: 2,
          // time: '17:00 - 17:10',
          header: 'Коростылев Евгений Владимирович',
          subheader: 'Московский физико-технический институт',
          main: '«Изучение эволюции структуры сегнетоэлектрического HZO в результате циклирования дифракционными методами на источнике синхротронного излучения»',
        },
        {
          id: 3,
          // time: '17:00 - 17:10',
          header: 'Зенкевич Андрей Владимирович',
          subheader: 'Московский физико-технический институт',
          main: '«Синхротронные исследования in operando на прототипах перспективных устройств наноэлектроники и спинтроники»',
        },
        {
          id: 4,
          // time: '17:00 - 17:10',
          header: 'Рощупкин Дмитрий Валентинович',
          subheader: 'Институт проблем технологии микроэлектроники',
          main: '«Перспективы применение синхротронного излучения для решения задач диагностики, метрологии и рентгеновской литографии при создании ЭКБ микроэлектроники»',
        },

      ],

      details_s3_1: [
        {
          id: 1,
          time: '12:00 - 12:15',
          header: 'Васильев Александр Леонидович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Развитие электронно-микроскопических исследований в НИЦ Курчатовский институт»',
        },
        {
          id: 2,
          time: '12:15 - 12:45',
          header: 'Боргардт Николай Иванович',
          subheader: 'НИУ МИЭТ',
          main: '«Исследование аморфизации кремния ионами ксенона методами электронной микроскопии и молекулярно-динамического моделирования»',
        },
        {
          id: 3,
          time: '12:45 - 13:15',
          header: 'Гутаковский Антон Константинович',
          subheader: 'ИФП РАН',
          main: '«Возможности аналитической просвечивающей электронной микроскопии высокого разрешения для исследования атомной структуры новых материалов»',
        },
        {
          id: 4,
          time: '13:15 - 13:30',
          header: 'Каратеев Игорь Андреевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Комплекс дифракционного картирования для просвечивающей электронной микроскопии»',
        },
        {
          id: 4,
          time: '13:30 - 13:50',
          header: 'Шенкарёв Захар Олегович',
          subheader: 'ИБХ РАН',
          main: '«Структурная основа модуляции болевого рецептора канала TRPA1 токсинами пауков»',
        },
      ],

      details_s3_2: [
        {
          id: 1,
          time: '14:30 - 15:00',
          header: 'Рогожкин Сергей Васильевич',
          subheader: 'ИТЭФ, НИЦ «Курчатовский институт»',
          main: '«Томографические атомно-зондовые исследования материалов»',
        },
        {
          id: 2,
          time: '15:00 - 15:15',
          header: 'Трунькин Игорь Николаевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Исследование структуры NbS3 методами электронной микроскопии»',
        },
        {
          id: 3,
          time: '15:15 - 15:30',
          header: 'Шабельникова Яна Леонидовна',
          subheader: 'ИПТМ РАН',
          main: '«Исследование методом ПЭМ морфологии и размеров треков от тяжелых ионов с энергией 0.08-0.4 МэВ/нуклон в YBCO и выделениях его вторичных фаз»',
        },
        {
          id: 4,
          time: '15:30 - 16:00',
          header: 'Приходько Кирилл Евгеньевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Спектроскопия потерь энергии электронов в исследовании функциональных материалов»',
        },
        {
          id: 5,
          time: '16:00 - 16:15',
          header: 'Хмеленин Дмитрий Николаевич',
          subheader: 'ККИФ, НИЦ «Курчатовский институт»',
          main: '«Структура композитов на основе пористых пленок PZT»',
        },
      ],

      details_s3_3: [
        {
          id: 1,
          time: '17:00 - 17:30',
          header: 'Якимов Евгений Борисович',
          subheader: 'ИПТМ РАН',
          main: '«Влияние облучения электронным пучком на спектры катодолюминесценции органо-неорганического перовскита CH3NH3PbBr3»',
        },
        {
          id: 2,
          time: '17:30 - 17:45',
          header: 'Пацаев Тимофей Дмитриевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Исследование in situ механических свойств полимерных материалов в камере растрового электронного микроскопа»',
        },
        {
          id: 3,
          time: '17:45 - 18:00',
          header: 'Сметанникова Софья Дмитриевна',
          subheader: 'ФГБОУ ВО «Тверской государственный университет»',
          main: '«Применение данных магнитно-силовой микроскопии для моделирования полей рассеяния объемных одноосных ферромагнетиков»',
        },
        {
          id: 4,
          time: '18:00 - 18:15',
          header: 'Соколов Леонид Владимирович',
          subheader: 'АО "РПКБ"',
          main: '«Исследование поверхности по границе раздела кремния со слоем стекловидного диэлектрика на образце МЭМС-КНИ чипа преобразователя давления методом растровой электронной микроскопии»',
        },
      ],

      details_s3_4: [
        {
          id: 1,
          time: '10:00 - 10:30',
          header: 'Абакумов Артем Михайлович',
          subheader: 'Сколтех',
          main: '«Электронная микроскопия в исследовании материалов для аккумуляторов»',
        },
        {
          id: 3,
          time: '10:30 - 10:45',
          header: 'Овчаров Алексей Валерьевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Микроструктурный анализ ВТСП лент 2-го поколения на основе (RE)BCO с искусственными центрами пиннинга различной природы»',
        },
        {
          id: 4,
          time: '10:45 - 11:00',
          header: 'Лукасов Максим Сергеевич',
          subheader: 'ККИФ, НИЦ «Курчатовский институт»',
          main: '«Фазовый состав и термоэлектрические свойства кристаллов CrxFe1-xSi2, выращенных методом направленной кристаллизации»',
        },
        {
          id: 5,
          time: '11:00 - 11:15',
          header: 'Приходько Александр Сергеевич',
          subheader: 'НИУ МИЭТ',
          main: '«Статистический анализ геометрических параметров и структурные исследования нанообразований на поверхности пленки Ge3Sb2Te6»',
        },
        {
          id: 6,
          time: '11:15 - 11:30',
          header: 'Герасимов Евгений Юрьевич',
          subheader: 'ИК СО РАН',
          main: '«Исследование процессов сегрегации частиц переходных металлов на поверхности перовскитных фаз методами просвечивающей электронной микроскопии»',
        },
      ],

      details_s3_5: [
        {
          id: 1,
          time: '12:00 - 12:30',
          header: 'Самыгина Валерия Ролановна',
          subheader: 'ККИФ, НИЦ «Курчатовский институт»',
          main: '«КриоЭМ структуры инактивированных флавивирусов»',
        },
        {
          id: 2,
          time: '12:30 - 12:50',
          header: 'Пичкур Евгений Борисович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Ингибировании трансляции пролин-богатыми пептидами»',
        },
        {
          id: 3,
          time: '12:50 - 13:10',
          header: 'Баймухаметов Тимур Нафисович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Крио-ЭМ структура большой рибосомной субчастицы Escherichia coli, собранной in vivo в отсутствие жизненно важного рибосомного белка uL5»',
        },
        // {
        //   id: 4,
        //   time: '13:10 - 13:30',
        //   header: 'А.В.Моисеенко',
        //   subheader: 'Биологический факультет МГУ',
        //   main: '«КриоЭМ реконструкция капсида гигантского бактериофага AR9»',
        // },
      ],

      details_s3_6: [
        {
          id: 1,
          time: '14:30 - 15:00',
          header: 'Мохов Андрей Владимирович',
          subheader: 'ГЕОХИ РАН',
          main: '«Роль электронной микроскопии в обнаружении на Луне самородных форм лантаноидов»',
        },
        {
          id: 2,
          time: '15:00 - 15:15',
          header: 'Горностаева Татьяна Александровна',
          subheader: 'ГЕОХИ РАН',
          main: '«Низкотемпературные конденсаты из импактитов кратера лонар (индия) и лунного реголита»',
        },
        {
          id: 3,
          time: '15:15 - 15:30',
          header: 'Лобода Анастасия Юрьевна',
          subheader: 'НИЦ «Курчатовский институт',
          main: '«Исследование материала паст в заполнении орнамента сосудов раннего железного века»',
        },
        {
          id: 4,
          time: '15:30 - 15:45',
          header: 'Мандрыкина Анастасия Викторовна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Возможности методов электронной микроскопии для изучения рецептуры изготовления античной краснолаковой керамики»',
        },
        {
          id: 5,
          time: '15:45 - 16:00',
          header: 'Созонтов Евгений Аркадьевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Перстневые вставки XIV века из раскопок немецкого двора в Великом Новгороде: комплексный анализ методами естественных наук»',
        },
        {
          id: 6,
          time: '16:00 - 16:15',
          header: 'Грешников Эдуард Аркадьевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Электронно-микроскопические исследования насекомого-паразита, обнаруженного на древнерусском текстиле 13 века (некрополь селище Чаадаево-5)»',
        },
      ],

      details_daria:[
        {
          id: 1,
          time: '10:00 - 10:05',
          header: 'Кулевой Тимур Вячеславович',
          subheader: 'ККТЭФ НИЦ КИ, руководитель проекта DARIA',
          main: '«Открытие конференции – вступительное слово»',
        },
        {
          id: 1,
          time: '10:05 - 10:35',
          header: 'Григорьев Сергей Валентинович',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Нейтронное рассеяние: перспективы компактного источника нейтронов DARIA»',
        },
        {
          id: 1,
          time: '10:35 - 10:50',
          header: 'Кравцов Евгений Алексеевич',
          subheader: 'ИФМ УрО РАН',
          main: '«Компактный источник нейтронов DARIA для Урала»',
        },
        {
          id: 1,
          time: '10:50 - 11:20',
          header: 'Кулевой Тимур Вячеславович',
          subheader: 'ККТЭФ НИЦ КИ, руководитель проекта DARIA',
          main: '«Проект DARIA: Компактные источники нейтронов в России – статус проекта»',
        },
        {
          id: 1,
          time: '11:20 - 11:40',
          header: 'Кофе-брейк',
          subheader: '',
          main: '',
        },
        {
          id: 1,
          time: '11:40 - 12:00',
          header: 'Изотов Иван Владимирович',
          subheader: 'ИПФ РАН',
          main: '«Результаты исследования ЭЦР протонного инжектора для ускорителя проекта DARIA»',
        },
        {
          id: 1,
          time: '12:00 - 12:10',
          header: 'Ситников Алексей Леонидович',
          subheader: 'ККТЭФ НИЦ КИ',
          main: '«Ускоритель протонов для проекта DARIA»',
        },
        {
          id: 1,
          time: '12:10 - 12:30',
          header: 'Кильметова И.В.',
          subheader: 'ККТЭФ НИЦ КИ',
          main: '«Гибридные линзы для ускорителя протонов проекта DARIA»',
        },
        {
          id: 1,
          time: '12:30 - 12:50',
          header: 'Гаврилов Сергей Александрович',
          subheader: 'ИЯИ РАН',
          main: '«Система контроля потерь пучка для сильноточного линейного ускорителя проекта DARIA»',
        },
        {
          id: 1,
          time: '13:00 - 14:00',
          header: 'Обед',
          subheader: '',
          main: '',
        },
        {
          id: 1,
          time: '14:00 - 14:20',
          header: 'Сидоркин Станислав Федорович',
          subheader: 'ИЯИ РАН',
          main: '«Принципы построения нейтронгенерирующей сборки для компактного нейтронного генератора»',
        },
        {
          id: 1,
          time: '14:20 - 14:40',
          header: 'Прокопович Павел Аликович',
          subheader: 'БФУ им.И.Канта',
          main: '«Мишень с вертикальной осью вращения и инжекторным охлаждением для компактного источника нейтронов»',
        },
        {
          id: 1,
          time: '14:40 - 15:00',
          header: 'Коваленко Никита Александрович',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Конструктив биологической защиты КИН DARIA. Распределение дозовых полей»',
        },
        {
          id: 1,
          time: '15:00 - 15:30',
          header: 'Антропов Николай Олегович, Попов Артем Ильич',
          subheader: 'ИФМ УрО РАН',
          main: '«Применение машинного обучения в управлении нейтронными установками»',
        },
        {
          id: 1,
          time: '15:30 - 15:50',
          header: 'Кофе-брейк',
          subheader: '',
          main: '',
        },
        {
          id: 1,
          time: '15:50 - 16:10',
          header: 'Павлов Константин Андреевич',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Установка малоуглового рассеяния нейтронов на холодном замедлителе компактного источника нейтронов»',
        },
        {
          id: 1,
          time: '16:10 - 16:30',
          header: 'Григорьева Наталья Анатольевна',
          subheader: 'ИФМ УрО РАН',
          main: '«Рефлектометр поляризованных нейтронов на холодном замедлителе компактного источника нейтронов»',
        },
        {
          id: 1,
          time: '16:30 - 16:50',
          header: 'Москвин Евгений Владимирович',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Порошковый дифрактометр для проекта DARIA»',
        },
        {
          id: 1,
          time: '17:00 - 19:00',
          header: '',
          subheader: '',
          main: '«Круглый стол – перспективы создания компактного источника нейтронов DARIA»',
        },
      ],

      details_s4: [
        {
          id: 1,
          time: '10:00 - 10:20',
          header: 'Алтынбаев Евгений Владимирович',
          subheader: 'НИЦ «Курчатовский институт»-ПИЯФ',
          main: '«Приборная база реакторного комплекса ПИК»',
        },
        {
          id: 2,
          time: '10:20 - 10:40',
          header: 'Гоголев Алексей Сергеевич',
          subheader: 'ТПУ',
          main: '«Синхротронные источники для геологии и геохимии: инфраструктура, возможности и проблемы»',
        },
        {
          id: 3,
          time: '10:40 - 11:00',
          header: 'Солдатов Александр Владимирович',
          subheader: 'ЮФУ',
          main: '«Диагностика материалов на основе спектроскопии рентгеновского поглощения - на пути к operando нанометрологии»',
        },
        {
          id: 4,
          time: '11:00 - 11:15',
          header: 'Прууэл Эдуард Рейнович',
          subheader: 'ИГиЛ СО РАН',
          main: '«Статус изготовления экспериментальной станции 1-3 «Быстропротекающие процессы» ЦКП «СКИФ»»',
        },
        {
          id: 5,
          time: '11:15 - 11:30',
          header: 'Зверев Дмитрий Алексеевич',
          subheader: 'БФУ',
          main: '«Преломляющая оптика для источников рентгеновского излучения 4-го поколения»',
        },
        {
          id: 6,
          time: '11:30 - 11:45',
          header: 'Прокопович Павел Аликович',
          subheader: 'ООО «НМУ», БФУ',
          main: '«Мобильные установки для исследования свойств материалов на синхротронных и нейтронных источниках»',
        },
        {
          id: 7,
          time: '11:45 - 12:00',
          header: 'Ходаков Михаил Дмитриевич',
          subheader: '',
          main: '«Современное оборудование для источников СИ»',
        },
        {
          id: 8,
          time: '12:00 - 12:15',
          header: 'Турищев Сергей Юрьевич',
          subheader: 'ФГБОУ ВО "ВГУ"',
          main: '«Расширение методов спектроскопии и микроскопии функциональных материалов в ультрамягкой рентгеновской области синхротронного излучения»',
        },
      ],

      details_s1_1: [
        {
          id: 1,
          time: '12:00 - 12:15',
          header: 'Менушенков Алексей Павлович',
          subheader: 'МИФИ',
          main: '«Сверхбыстрая динамика электронных и структурных корреляций в высокотемпературных сверхпроводниках»',
        },
        {
          id: 2,
          time: '12:15 - 12:30',
          header: 'Титова Светлана Геннадьевна',
          subheader: 'Институт металлургии Уральского отделения Российской академии наук',
          main: '«Исследование двойного манганита NdBaMn2O6 методами XANES и XMCD»',
        },
        {
          id: 3,
          time: '12:30 - 12:45',
          header: 'Аракчеев Андрей Владимирович',
          subheader: 'ИФХЭ РАН',
          main: '«ПРИНУДИТЕЛЬНАЯ СУПРАМОЛЕКУЛЯРНАЯ СБОРКА ТЕТРАПИРРОЛЬНЫХ КОМПЛЕКСОВ d-МЕТАЛЛОВ В МОНОСЛОЯХ ЛЕНГМЮРА»',
        },
        {
          id: 4,
          time: '12:45 - 13:00',
          header: 'Гуда Александр Александрович',
          subheader: 'ЮФУ',
          main: '«In situ диагностика каталитических реакций при высоком давлении методом спектроскопии рентгеновского поглощения»',
        },
        {
          id: 5,
          time: '13:00 - 13:15',
          header: 'Волков Николай Васильевич',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Исследование секторообразных производных бензолсульфоновой кислоты с двухвалентными катионами бария с использованием источника СИ»',
        },
        {
          id: 6,
          time: '13:15 - 13:30',
          header: 'Асылкаев Артур Марселевич',
          subheader: 'ИГиЛ СО РАН',
          main: '«Исследование сжатия конструкционных материалов под действием взрывчатых веществ с помощью синхротронного излучения»',
        },
        {
          id: 7,
          time: '13:30 - 13:45',
          header: 'Иванов Никита Павлович',
          subheader: 'ДВФУ',
          main: '«Механизмы адсорбции U(VI) слоистыми двойными гидроксидами ZN-AL-СДГ по данным EXAFS-спектроскопии»',
        },
        {
          id: 8,
          time: '13:45 - 14:00',
          header: 'Денисов Владимир Викторович',
          subheader: 'ИСЭ СО РАН',
          main: '«Ключевые результаты проекта «In situ методы синхротронных исследований многослойных функциональных структур с уникальными параметрами и свойствами, созданных пучково- плазменной инженерией поверхности»',
        },
      ],

      details_s1_2: [
        {
          id: 1,
          time: '15:00 - 15:15',
          header: 'Копица Геннадий Петрович',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Исследование надмолекулярной организации ионогелей на основе ионной жидкости OMIM BF4 и Аэросила методом МУРР»',
        },
        // {
        //   id: 2,
        //   time: '15:15 - 15:30',
        //   header: 'Лис Ольга Николаевна',
        //   subheader: 'ОИЯИ',
        //   main: '«Влияние высокого давления на кристаллическую, магнитную структуру и колебательные спектры ван-дер-ваальсовых магнетиков»',
        // },
        // {
        //   id: 3,
        //   time: '15:30 - 15:45',
        //   header: 'Жакетов Владимир Дмитриевич',
        //   subheader: 'ОИЯИ',
        //   main: '«Исследования низкоразмерных 2d магнитных и сверхпроводящих гетероструктур с помощью рефлектометрии поляризованных нейтронов »',
        // },
        {
          id: 4,
          time: '15:15 - 15:30',
          header: 'Ромашко Полина Евгеньевна',
          subheader: 'ИФМ УрО РАН',
          main: '«Применение нейтронного излучения для исследования литий-ионных материалов»',
        },
        {
          id: 5,
          time: '15:30 - 15:45',
          header: 'Рогожкин Сергей Васильевич',
          subheader: 'НИЦ "Курчатовский институт"',
          main: '«Исследование наноструктуры дисперсно-упрочненных оксидами сталей методами малоуглового рассеяния нейтронов»',
        },
        {
          id: 6,
          time: '15:45 - 16:00',
          header: 'Карпов Иван Дмитриевич, Эм Вячеслав Терентьевич',
          subheader: 'НИЦ "Курчатовский институт"',
          main: '«Исследование остаточных напряжений методом дифракции нейтронов высокого пространственного разрешения»',
        },
        {
          id: 7,
          time: '16:00 - 16:15',
          header: 'Ковалев Александр Денисович',
          subheader: 'Университет науки и технологий МИСИС',
          main: '«Магнитные свойства шпинелей CoxFe3-xO4 (x = 0,5; 1), полученных механохимическим синтезом »',
        },
        {
          id: 8,
          time: '16:15 - 16:30',
          header: 'Исакова Наталья Николаевна',
          subheader: 'НИЦ "Курчатовский институт"',
          main: '«Закономерные связи состава, атомной, реальной структуры и свойств кристаллов-суперпротоников»',
        },
      ],

      details_s2_1: [
        {
          id: 1,
          time: '12:30 - 12:50',
          header: 'Артюков Игорь Анатольевич',
          subheader: 'ФИАН',
          main: '«Исследование следов натрия в тканях сердца методом флуоресцентной рентгеновской микроскопии с использованием синхротронного излучения»',
        },
        {
          id: 2,
          time: '12:50 - 13:10',
          header: 'Павлычев Андрей Алексеевич',
          subheader: 'СПБГУ',
          main: '«Возрастные изменения атомно-молекулярной архитектуры костной ткани: стратегия их замедления»',
        },
        {
          id: 3,
          time: '13:10 - 13:30',
          header: 'Соловьев Алексей Николаевич',
          subheader: 'МРНЦ им. А.Ф. Цыба - филиал ФГБУ "НМИЦ радиологии"',
          main: '«Эффективные вычислительные подходы к биологическому планированию нейтронозахватной терапии»',
        },
        {
          id: 4,
          time: '13:30 - 14:00',
          header: 'Шнырков Олег Дмитриевич',
          subheader: 'НИЦ "Курчатовский институт" - ПИЯФ',
          main: '«Исследование фрактальной структуры лиственных и хвойных деревьев с помощью моделирования экспериментов по малоугловому рассеянию нейтронов»',
        },
      ],

      details_s2_2: [
        {
          id: 1,
          time: '14:30 - 14:50',
          header: 'Самыгина Валерия Ролановна',
          subheader: 'НИЦ "Курчатовский институт"',
          main: '«Кристаллическая упаковка как инструмент исследования функциональных особенностей белков»',
        },
        {
          id: 2,
          time: '14:50 - 15:10',
          header: 'Воронова Анастасия Андреевна',
          subheader: 'ИНЭОС РАН',
          main: '«Конъюгаты биметаллических наночастиц AuFe с метотрексатом: синтез, структура и биологическая активность»',
        },
        {
          id: 3,
          time: '15:10 - 15:30',
          header: 'Третьякова Анастасия Никитична',
          subheader: 'ИНЭОС РАН',
          main: '«Композиты на основе полимеров (коллаген, хитозан), модифицированных наночастицами серебра и меди: синтез, исследование методами рентгеновской спектроскопии и биологическая активность»',
        },
        {
          id: 4,
          time: '15:30 - 15:50',
          header: 'Снетков Пётр Петрович',
          subheader: 'ИТМО',
          main: '«Исследование полимерных матриц на основе гиалуроновой кислоты методом малоуглового рентгеновского рассеяния»',
        },
      ],
    }
  },

  methods: {
    goto_daria(){
      window.open('https://www.itep.ru/daria2024/AboutConference.php', '_blank');
    }
  }

  

};
</script>
<style lang="scss" scoped>
  hr{
    margin: 10px;
  }

  .prog-text{
    font-style: italic;
    color:rgb(4, 43, 75);
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
